<script lang="ts">
    import { RangeCalendar as RangeCalendarPrimitive } from "bits-ui";
    import ChevronRightIcon from "@lucide/svelte/icons/chevron-right";
    import { buttonVariants, type ButtonVariant } from "../../../components/ui/button/index.js";
    import { cn } from "../../../utils.js";

    let {
        ref = $bindable(null),
        class: className,
        children,
        variant = "ghost",
        ...restProps
    }: RangeCalendarPrimitive.NextButtonProps & {
        variant?: ButtonVariant;
    } = $props();
</script>

{#snippet Fallback()}
    <ChevronRightIcon class="size-4" />
{/snippet}

<RangeCalendarPrimitive.NextButton
    bind:ref
    class={cn(
        buttonVariants({ variant }),
        "size-(--cell-size) bg-transparent p-0 select-none disabled:opacity-50 rtl:rotate-180",
        className,
    )}
    children={children || Fallback}
    {...restProps}
/>
